import type { GemxQlQueryResponse, GemxQlQueryVariables } from '~/core/gemxql/graphql';
import type { UseQueryOptions } from '@tanstack/react-query';

import { useGemxQlNamedQuery } from '~/core/gemxql/api';

const NAME = 'CampaignAnalyticQL';

export const useCustomCampaignAnalyticQueryV2 = <TData = GemxQlQueryResponse, TError = unknown>(
  variables: GemxQlQueryVariables,
  options?: UseQueryOptions<GemxQlQueryResponse, TError, TData>,
) => useGemxQlNamedQuery<TData, TError>({ name: NAME, variables }, options);

useCustomCampaignAnalyticQueryV2.getKey = (variables: GemxQlQueryVariables) => [NAME, variables];
